import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
  combineLatest,
  ignoreElements,
  merge,
  of,
  switchMap,
  take,
  tap,
  timer,
} from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-impersonate-user',
  imports: [MatProgressSpinner, MatCardModule, MatButton, RouterLink],
  templateUrl: './impersonate-user.component.html',
  styleUrl: './impersonate-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonateUserComponent {
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected readonly impersonationResponse = toSignal(
    combineLatest([
      this.route.queryParams,
      this.authService.signOutObservable(false),
    ]).pipe(
      take(1),
      tap(() =>
        // strip token from URL
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { token: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        }),
      ),
      switchMap(([params, _]) => {
        const token = params['token'];
        const authAction$ = token
          ? this.authService.signInWithCustomToken(token)
          : of({
              success: false,
              userCredential: null,
              message: 'No token provided.',
            });
        return authAction$.pipe(
          switchMap((response) =>
            merge(
              of(response),
              timer(3000).pipe(
                tap(() => {
                  if (response?.success) {
                    this.router.navigate(['/dashboard'], { replaceUrl: true });
                  }
                }),
                ignoreElements(),
              ),
            ),
          ),
        );
      }),
    ),
  );
}
